import {
  GET_SERVICES_SUCCESS,
  SERVICES_LOADING,
  SET_SERVICE,
  GET_SERVICE_DETAILS_SUCCESS,
  GET_SCROLL_SERVICES_SUCCESS,
} from "./Types";

const INITIAL_STATE = {
  services: [],
  service: {},
  meta: {},
  count: 0,
  param: {},
  load: {
    loading: false,
    type: "",
  },
};

export const servicesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SERVICES_LOADING:
      return {
        ...state,
        load: {
          loading: action.payload.loading,
          type: action.payload.type,
        },
      };
    case GET_SERVICES_SUCCESS:
      return {
        ...state,
        services: action.payload.data?.services,
        count: action.payload.extra?.total_count,
      };
    case SET_SERVICE:
      return {
        ...state,
      };
    case GET_SERVICE_DETAILS_SUCCESS:
      return {
        ...state,
        service: action.payload.data?.service,
      };
    case GET_SCROLL_SERVICES_SUCCESS:
      return {
        ...state,
        services: [...state.services, ...action.payload.data?.services],
      };
    default:
      return state;
  }
};
